module.exports = __webpack_public_path__ + "img/CellSystems_Liyuzhe_2024.c26c0138.png";